/* eslint-disable @nx/enforce-module-boundaries */
import { Component, inject } from '@angular/core';
import { DriverService } from 'admin-drivers/src/app/api/services/driver.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { FormatLicenseCategoriesPipe } from '../../../pipes/format-license-categories.pipe';
import { DatePipe } from '@angular/common';
import { License } from 'admin-drivers/src/app/common/models/License';

@Component({
  selector: 't-llevo-driver-license-detail-tab',
  standalone: true,
  imports: [
    PreloadImgComponent,
    FormatLicenseCategoriesPipe,
    DatePipe,
  ],
  template: `
    @for(license of data(); track license){
    <div
      class="row w-100 pt-2 pb-3 border-bottom"
      [class.border-bottom]="$count > 1"
    >
      <table class="details-table col-12 col-lg-6 mb-2">
        <tr>
          <td>Número de licencia:</td>
          <td>{{ license.licenseNumber }}</td>
        </tr>
        <tr>
          <td>Categorías:</td>
          <td>{{ license.categories | formatLicenseCategories }}</td>
        </tr>
        <tr>
          <td>Fecha de expedición:</td>
          <td>{{ license.expeditionDate | date : 'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <td>Año de vencimiento:</td>
          <td>{{ license.expiredYear }}</td>
        </tr>
      </table>
      <commonui-preload-img
        #img
        class="col-10 col-lg-6"
        [urlImg]="images[$index]"
        [containerClass]="'shadow-sm'"
        imgClass="w-100 h-100"
        [containerHeight]="100"
        [containerWidth]="100"
        unit="%"
        [style.height]="img.onErrorCount > 1 ? '160px !important' : ''"
      ></commonui-preload-img>
    </div>
    }
  `,
})
export class DriverLicenseDetailTabComponent {
  private srv = inject(DriverService);
  protected images: string[] = [];
  protected data = toSignal<License[] | null>(
    this.srv.item$.pipe(
      map((data) => {
        if (data) {
          this.images = [];
          data.licenses.forEach((license) => {
            this.images.push(license.image);
          });
          return data.licenses;
        }
        return null;
      })
    )
  );
}
